export default __webpack_public_path__ + "static/media/modalLogo.ea0d914b.png";